import React from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { getMockTemplates } from 'services/sectionService';
import useIELTSStore from 'utils/ieltsStore';
import Session from 'utils/Session';

const ALL_FOUR_SECTIONS = ['listening', 'reading', 'writing', 'speaking'];

function hasAllFourSections(template) {
    const names = (template.sections || []).map((s) =>
        (s.name || s.sectionType || s.type || '').toLowerCase()
    );
    return ALL_FOUR_SECTIONS.every((sec) => names.includes(sec));
}

export default function StartMockTest() {
    const navigate = useNavigate();
    const setMock = useIELTSStore((state) => state.setMock);

    React.useEffect(() => {
        if (!Session.isLoggedIn()) {
            navigate('/register', { replace: true });
            return;
        }

        let cancelled = false;

        (async () => {
            try {
                const data = await getMockTemplates({ mockType: 'ielts', pageSize: 30, pageNumber: 1 });
                const templates = Array.isArray(data) ? data : data?.templates || [];
                const firstFull = templates.find(hasAllFourSections);

                if (cancelled) return;

                if (!firstFull) {
                    navigate('/practice', { replace: true });
                    return;
                }

                const sections = firstFull.sections || [];
                setMock({
                    mockType: 'ielts',
                    sections,
                    duration: sections.reduce((acc, s) => acc + (s.duration || 0), 0),
                    completedSections: [],
                });

                navigate('/ielts/assessment-intro', { replace: true });
            } catch {
                navigate('/practice', { replace: true });
            }
        })();

        return () => { cancelled = true; };
    }, []);

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#F8FAFC',
            }}
        >
            <CircularProgress sx={{ color: '#0284C5' }} />
        </Box>
    );
}
